export var CUSTOM_PLANS_MANAGEMENT_PATH = '/management/';
export var PLANS_LIST_PATH = "".concat(CUSTOM_PLANS_MANAGEMENT_PATH, "plans/");
export var PACKAGES_LIST_PATH = "".concat(CUSTOM_PLANS_MANAGEMENT_PATH, "packages/");
export var PARTNER_PLANS_LIST_PATH = "".concat(CUSTOM_PLANS_MANAGEMENT_PATH, "partner-plans/");
export var PARTNER_PACKAGES_LIST_PATH = "".concat(CUSTOM_PLANS_MANAGEMENT_PATH, "partner-packages/");
export var PACKAGE_CREATE_PATH = "".concat(PACKAGES_LIST_PATH, "create");
export var PARTNER_PACKAGE_CREATE_PATH = "".concat(PARTNER_PACKAGES_LIST_PATH, "create");
export var PACKAGE_EDIT_PATH = "".concat(PACKAGES_LIST_PATH, ":packageId/modify");
export var PARTNER_PACKAGE_EDIT_PATH = "".concat(PARTNER_PACKAGES_LIST_PATH, ":packageId/modify");
export var DIRECT_PLAN_CREATE_PATH = "".concat(PLANS_LIST_PATH, "create");
export var PARTNER_PLAN_CREATE_PATH = "".concat(PARTNER_PLANS_LIST_PATH, "create");
export var DIRECT_PLAN_EDIT_PATH = "".concat(PLANS_LIST_PATH, ":planId/modify");
export var PARTNER_PLAN_EDIT_PATH = "".concat(PARTNER_PLANS_LIST_PATH, ":planId/modify");
export var getDirectPlanEditPath = function getDirectPlanEditPath(planId) {
    return "".concat(PLANS_LIST_PATH).concat(planId, "/modify");
};
export var getPartnerPlanEditPath = function getPartnerPlanEditPath(planId) {
    return "".concat(PARTNER_PLANS_LIST_PATH).concat(planId, "/modify");
};
